<nb-card style="width: 800px; max-width: 95vw; max-height: 80vh; display: flex; flex-direction: column;"
    (click)="$event.stopPropagation()" (mousedown)="$event.preventDefault(); $event.stopPropagation()">
    <nb-card-header>Choisir mes produits de backup</nb-card-header>
    <nb-card-body style="overflow-y: auto; padding: 0;">
        <nb-accordion>
            <nb-accordion-item *ngFor="let cat of categories" (collapsedChange)="onCategoryExpand(cat, !$event)">
                <nb-accordion-item-header>
                    {{ cat.label }}
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                    <div *ngIf="loadingCategories.has(cat.id)"
                        style="display: flex; justify-content: center; padding: 20px;">
                        <nb-spinner status="primary"></nb-spinner>
                    </div>
                    <div *ngIf="!loadingCategories.has(cat.id) && productsByCategory.get(cat.id)?.length"
                        class="product-grid">
                        <div *ngFor="let product of productsByCategory.get(cat.id)" class="product-item"
                            [class.selected]="selectedProductIds.has(product.product_id)" (click)="toggleProduct(product)">
                            <img [src]="product.image_url_1 || 'assets/placeholder-image.png'" alt="Product Image">
                            <span class="product-name" [title]="product.name">{{ product.name }}</span>
                            <nb-checkbox status="danger" [checked]="selectedProductIds.has(product.product_id)"></nb-checkbox>
                        </div>
                    </div>
                    <div *ngIf="!loadingCategories.has(cat.id) && !productsByCategory.get(cat.id)?.length"
                        style="text-align: center; padding: 10px; color: #8f9bb3;">
                        Aucun produit disponible.
                    </div>
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion>
    </nb-card-body>
    <nb-card-footer style="display: flex; justify-content: flex-end; gap: 10px;">
        <button nbButton status="basic" (click)="cancel()">Annuler</button>
        <button nbButton status="danger" (click)="submit()">Valider ({{ selectedProductIds.size }})</button>
    </nb-card-footer>
</nb-card>